import ClaimsDashboard from 'pages/claims-dashboard/ClaimsDashboard.vue';
import {beforeEnter} from 'services/routingMethods';

export default [
    {
        name: 'claims',
        path: '/claims',
        beforeEnter: (to, from, next) => beforeEnter(to, from, next),
        component: ClaimsDashboard,
    },
];



// WEBPACK FOOTER //
// ./src/pages/claims-dashboard/routes.js